import { useMutation } from '@tanstack/react-query';
import { createUserWithEmailAndPassword, User } from 'firebase/auth';
import UserCredentials from '@/features/auth/signup/types/userCredentials.ts';
import { auth } from '@/lib/firebase';
import { getFirebaseErrorMessage } from '@/utils/exceptions/firebaseErrors.ts';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';
import { FirebaseError } from 'firebase/app';

export default function useCreateUser(redirectUrl?: string) {
  const navigate = useNavigate();

  const createUser = async (
    userCredentials: UserCredentials,
  ): Promise<User> => {
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      userCredentials.email,
      userCredentials.password,
    );
    return userCredential.user;
  };

  return useMutation({
    mutationFn: createUser,
    onSuccess: () => {
      toast.success('Konto utworzone');
      navigate({
        to: '/auth/email-verification',
        search: redirectUrl ? { redirect: redirectUrl } : {},
      });
    },
    onError: (error) => {
      if (error instanceof FirebaseError) {
        const errorMessage = getFirebaseErrorMessage(error?.code);
        toast.error(errorMessage);
      } else {
        toast.error('Błąd rejestracji', {
          description: error.message,
        });
      }
    },
  });
}
